import React from 'react'

import styles from './Results.module.scss'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { useResultsCareer } from './hooks'
import { ResultsTable } from './common/ResultsTable'
import { JobSeekerModal } from 'components/modals/AddJobSeekerModal/AddJobSeekerModal'
import { DeleteJobSeekerModal } from 'components/modals/DeleteJobSeekerModal/DeleteJobSeekerModal'

export const Results = () => {
  const { state, handlers } = useResultsCareer()
  const { candidate, search, isOverviewModalOpen, isDeleteJobSeekerOpen } =
    state
  const {
    setSearch,
    handleCopy,
    handleDelete,
    handleEdit,
    handleOverviewModalClose,
    handleOverviewModalConfirm,
    handleDeleteJobSeekerClose,
    handleDeleteJobSeekerConfirm,
  } = handlers

  return (
    <>
      <Pane.Header className={styles.header}>
        <SearchWidget query={search} onChange={setSearch} />
      </Pane.Header>
      <ResultsTable
        search={search}
        handleCopy={handleCopy}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />
      <JobSeekerModal
        onCancel={handleOverviewModalClose}
        onClose={handleOverviewModalClose}
        onConfirm={handleOverviewModalConfirm}
        isOpen={isOverviewModalOpen}
        {...{ candidate }}
      />
      <DeleteJobSeekerModal
        onCancel={handleDeleteJobSeekerClose}
        onClose={handleDeleteJobSeekerClose}
        onConfirm={handleDeleteJobSeekerConfirm}
        isOpen={isDeleteJobSeekerOpen}
      />
    </>
  )
}
